import $ from "jquery";
import updateProduct from "./updateProduct";

export default function () {
    const productsAccordion = document.querySelector('#productsAccordion');
    if (productsAccordion) {
        productsAccordion.addEventListener('hidden.bs.collapse', e => {
            e.target.previousElementSibling.classList.remove('active');
            $(e.target).off('change');
        });
        productsAccordion.addEventListener('show.bs.collapse', e => {
            e.target.previousElementSibling.classList.add('active');
            if (e.target.dataset.id == window.lastProduct) {
                return;
            }
            updateProduct(e.target);
        });
    }
}
